export const siteConfig = {
  name: '福利视频导',
  tagline: '精选内容聚合平台',
  description: '福利视频导为您汇聚全网优质视频内容，精准分类导航，一站式发现热门福利视频资源。无论您寻找娱乐、学习还是生活类视频，福利视频导都能帮您快速定位，节省筛选时间，享受高效便捷的视频导航体验。',
  keywords: '福利视频导,福利视频导航,视频资源导航,热门视频聚合,免费视频导航,精选视频推荐,视频分类导航',
  url: 'https://www.fulishipindao.com',
  email: 'contact@fulishipindao.com',
  foundingYear: 2024,
  stats: {
    totalVideos: '50,000+',
    categories: 8,
    dailyVisitors: '100,000+',
    articlesPublished: '1,200+',
  },
  brandIntro: '福利视频导成立于2024年，是国内领先的视频内容聚合导航平台。我们致力于为用户提供全网最全面、最精准的视频资源分类导航服务。通过智能推荐算法与人工精选相结合的方式，福利视频导帮助用户在海量视频内容中快速发现优质资源。无论是综艺娱乐、学习教育、生活技巧还是科技数码，福利视频导都能满足您的多元化需求。',
  reputation: [
    {
      name: '张先生',
      role: '资深视频创作者',
      content: '福利视频导是我每天必逛的网站，分类清晰，推荐精准，帮我发现了大量优质内容灵感。强烈推荐给所有视频爱好者！',
      rating: 5,
    },
    {
      name: '李女士',
      role: '自媒体运营',
      content: '作为一个内容创作者，福利视频导让我能快速了解行业动态和热门趋势，对选题策划帮助很大。',
      rating: 5,
    },
    {
      name: '王同学',
      role: '大学生',
      content: '学习类视频资源特别丰富，从编程到外语，想要的教程基本都能找到。界面简洁，体验很好。',
      rating: 5,
    },
    {
      name: '赵女士',
      role: '全职妈妈',
      content: '美食和生活类视频特别实用，学会了做很多新菜式。推荐给所有想要提升生活品质的朋友。',
      rating: 4,
    },
  ],
};